import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-buy',
    templateUrl: './admin-buy.component.html',
    styleUrl: './admin-buy.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminBuyComponent {

}
